import {
    getCookie,
    setCookie,
    delCookie,
    setLocalStorage,
    getLocalStorage,
    delLocalStorage
} from '@/util/storage';

// #1 constant
// 距离判断维度
// export const FELLOW_NIO_HOUSE_CODE = 0; // Fellow门店
export const COORDINATES_CODE = 1; // 指定坐标
export const NEAREST_NIO_HOUSE_CODE = 10; // 最近的门店
export const NEAREST_CHARGING_PILE_CODE = 20; // 最近的充电桩
export const NEAREST_EXCHANGE_STATION_CODE = 30; // 最近的换电站

// #2 function
function setLoginStorageAndCookie(expireHour = 24) {
  const urlParams = new URLSearchParams(window.location.search);
  const data = JSON.parse(urlParams.get('d'));
  const ts = new Date();
  const expireTimeTimestamp = ts.getTime() + expireHour * 60 * 60 * 1000; // 过期时间戳 ms

  // 设置localStorage
  setLocalStorage('nio_h5_at', data.nio_h5_at);
  setLocalStorage('nio_h5_tt', data.nio_h5_tt);
  setLocalStorage('nio_h5_et', expireTimeTimestamp); // 过期时间自定义，没取返回的nio_h5_et
  setLocalStorage('nio_h5_aid', data.nio_h5_aid);
  // 设置cookie bak
  setCookie('nio_h5_at', data.nio_h5_at, expireHour);
  setCookie('nio_h5_tt', data.nio_h5_tt, expireHour);
  setCookie('nio_h5_et', expireTimeTimestamp, expireHour);
  setCookie('nio_h5_aid', data.nio_h5_aid, expireHour);
};

function delLoginStorageAndCookie() {
  delLocalStorage('nio_h5_at');
  delLocalStorage('nio_h5_tt');
  delLocalStorage('nio_h5_et');
  delLocalStorage('nio_h5_aid');
  delCookie('nio_h5_at');
  delCookie('nio_h5_tt');
  delCookie('nio_h5_et');
  delCookie('nio_h5_aid');
};

function getAccessToken() {
    const expiresTime =
        getLocalStorage('nio_h5_et') || getCookie('nio_h5_et') || '';
    const ts = new Date();

    if (expiresTime < ts.getTime()) {
        console.log('_getH5Authorization at expires');
        delLoginStorageAndCookie();
        return undefined;
    }
    const accessToken =
        getLocalStorage('nio_h5_at') || getCookie('nio_h5_at') || '';
    const tokenType =
        getLocalStorage('nio_h5_tt') || getCookie('nio_h5_tt') || 'Bearer';

    if (!accessToken) {
        return undefined;
    }
    return `${tokenType} ${accessToken}`;
};



// WEBPACK FOOTER //
// ./src/util/dmp/site-code.js